/**
 * Retrieves the font family from primary or overrides from the theme.
 *
 * @param {string} fontFamilyType
 * @param {string} fontWeight
 * @param {Object} theme
 * @param {string} typePreset
 * @returns {string} fontFamily
 */
export default function getFontFamily(_ref) {
  var _theme$text$typePrese, _theme$text, _theme$text$typePrese2;

  var fontFamilyType = _ref.fontFamilyType,
      fontWeight = _ref.fontWeight,
      theme = _ref.theme,
      typePreset = _ref.typePreset;
  var ffType = fontFamilyType === 'secondary' ? 'sec' : 'pri';
  return (_theme$text$typePrese = theme === null || theme === void 0 ? void 0 : (_theme$text = theme.text) === null || _theme$text === void 0 ? void 0 : (_theme$text$typePrese2 = _theme$text[typePreset]) === null || _theme$text$typePrese2 === void 0 ? void 0 : _theme$text$typePrese2.fontFamily) !== null && _theme$text$typePrese !== void 0 ? _theme$text$typePrese : theme["ff_".concat(ffType, "_").concat(fontWeight)];
}